/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';

// No formsy here despite the name. This exports the bare component - the withFormsy and
// propTypes imports it used to carry were never applied to anything, and formsy-react 2
// stopped exporting propTypes anyway. Its parents pass `value` and `storeText` directly.

class FormTextarea extends Component {
  changeValue = (e) => {
    const { name } = e.target;
    const { storeText } = this.props;
    if (storeText) {
      storeText(name, e.currentTarget.value);
    }
  };

  render() {
    const {
      name, title, value, action,
    } = this.props;

    return (
      <div className="flex mb-7 w-full flex-col">
        <label className="flex flex-col font-americaMonoRegular text-xs uppercase" htmlFor={name}>
          {title}
          <textarea onChange={this.changeValue} name={name} value={value} className={`mt-2 outline-none rounded-lg border-1 p-2 h-32 ${(action === 'display' || action === 'delete') && 'bg-grey'} ${(action === 'create' || action === 'modify') && 'bg-white'}`} />
          {/* ${showError() ? 'border-red text-red' : 'border-black text-black'} */}
        </label>
      </div>
    );
  }
}

FormTextarea.propTypes = {};

export default FormTextarea;
